import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import { Link, useLocation } from 'react-router-dom';
import relendLogo from '../assets/relend-logo.svg';
import dashboardIconSelected from '../assets/navBar/dashboardIconSe.svg';
import dashboardIconUnselected from '../assets/navBar/dashboardIconUn.svg';
import aboutIconSelected from '../assets/navBar/aboutIconSe.svg';
import aboutIconUnselected from '../assets/navBar/aboutIconUn.svg';
import { ConnectButton } from '../components/ConnectButton';
import liqIconSelected from '../assets/navBar/liqIconSe.svg';
import liqIconUnselected from '../assets/navBar/liqIconUn.svg';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const LogoContainer = styled(Box)({
  width: '45%',
  maxWidth: '300px',
  '& img': {
    width: '100%',
    height: 'auto',
    maxHeight: '4rem',
    display: 'block'
  }
});

const TopNavBar: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname.slice(1).split('/')[0] || 'dashboard';

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem',
        paddingLeft: { xs: '0.5rem', sm: '4rem' },
        paddingRight: { xs: '1rem', sm: '4rem' }
      }}
    >
      <LogoContainer>
        <a href="https://relend.network" target="_blank" rel="noopener noreferrer">
          <img src={relendLogo} alt="Relend Logo" />
        </a>
      </LogoContainer>
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          gap: '1rem'
        }}
      >
        <Button
          component={Link}
          to="/about"
          sx={{ color: currentPath === 'about' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF' }}
          startIcon={
            currentPath === 'about' ? <RocketLaunchIcon sx={{ color: 'rgba(4, 255, 218, 1)' }} /> : <RocketLaunchIcon />
          }
        >
          RELEND Units
        </Button>
        <Button
          component={Link}
          to="/dashboard"
          sx={{ color: currentPath === 'dashboard' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF' }}
          startIcon={
            <img src={currentPath === 'dashboard' ? dashboardIconSelected : dashboardIconUnselected} alt="Dashboard" />
          }
        >
          Relend Vault
        </Button>
        <Button
          component={Link}
          to="/liquid-instances"
          sx={{ color: currentPath === 'liquid-instances' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF' }}
          startIcon={
            <img src={currentPath === 'liquid-instances' ? liqIconSelected : liqIconUnselected} alt="Liq. Instances" />
          }
        >
          rUSDC
        </Button>
        <Button
          component={Link}
          to="/learn"
          sx={{ color: currentPath === 'learn' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF' }}
          startIcon={<img src={currentPath === 'learn' ? aboutIconSelected : aboutIconUnselected} alt="About" />}
        >
          Learn
        </Button>
      </Box>
      <Box display="flex" alignItems="center" width={{ xs: '35%', sm: '45%' }} maxWidth="300px">
        <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Box
            sx={{
              visibility:
                location.pathname === '/liquid-instances' ||
                location.pathname === '/about' ||
                location.pathname === '/learn'
                  ? 'hidden'
                  : 'visible',
              width: '100%'
            }}
          >
            <ConnectButton />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TopNavBar;
